import { useState, useEffect } from 'react';
import { ref, onValue, query, orderByChild, equalTo } from 'firebase/database';
import { database } from '../config/firebase';
import { DeviceUpdate } from '../types';
import { parseUpdateStatus } from '../utils/updates';


interface DeviceUpdatesState {
  updates: DeviceUpdate[];
  loading: boolean;
  error: string | null;
}

export function useDeviceUpdates(deviceId: string, isAuthenticated: boolean = false): DeviceUpdatesState {
  const [updates, setUpdates] = useState<DeviceUpdate[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!isAuthenticated || !deviceId) {
      setUpdates([]);
      setLoading(false);
      return () => {};
    }

    setLoading(true);
    
    // Carregando todos e filtrando
    const updatesRef = ref(database, 'updates');
    
    const unsubscribe = onValue(updatesRef, (snapshot) => {
      try {
        if (snapshot.exists()) {
          const updatesData = snapshot.val();
          if (typeof updatesData === 'object' && updatesData !== null) {
            const updatesArray: DeviceUpdate[] = Object.entries(updatesData)
              .map(([key, value]: [string, any]) => {
                // Processar os dados da atualização
                const update: DeviceUpdate = {
                  id: key,
                  apkUrl: value.apkUrl || '',
                  deviceId: value.deviceId || '',
                  status: parseUpdateStatus(value.status),
                  createdAt: Number(value.createdAt) || 0,
                  updatedAt: Number(value.updatedAt) || 0,
                  updateType: value.updateType,
                  errorMessage: value.errorMessage || undefined,
                  errorTimestamp: value.errorTimestamp ? Number(value.errorTimestamp) : undefined
                };
                return update;
              })
              .filter(update => update.deviceId === deviceId)
              .sort((a, b) => b.createdAt - a.createdAt); // Ordena do mais recente para o mais antigo
            
            setUpdates(updatesArray);
          } else {
            setUpdates([]);
          }
        } else {
          setUpdates([]);
        }
        setLoading(false);
      } catch (err) {
        console.error('Erro ao processar dados de atualizações:', err);
        setError(err instanceof Error ? err.message : 'Erro desconhecido');
        setLoading(false);
      }
    }, (err) => {
      setError(err instanceof Error ? err.message : 'Erro desconhecido');
      setLoading(false);
    });
    
    return () => unsubscribe();
  }, [deviceId, isAuthenticated]);

  return { updates, loading, error };
} 